import { useState } from 'react'

import { sdk } from '../../config'
import { handleSdkError } from '../../utils'

interface Hook {
  downloadInvoice: () => Promise<void>
  loading: boolean
}

const downloadInvoiceRaw = sdk.downloadInvoicePdfByApiKeyRaw.bind(sdk)

const useDownloadInvoice: (apiKey: string) => Hook = (apiKey) => {
  const [loading, setLoading] = useState<boolean>(false)
  const downloadInvoice = async () => {
    try {
      setLoading(true)
      const response = (await downloadInvoiceRaw({ xAPIKey: apiKey })).raw
      const blob = await response.blob()

      // From the GitHub Gist: https://gist.github.com/devloco/5f779216c988438777b76e7db113d05c,
      // it is necessary to create a new Blob with an explicit MIME type for browsers
      // other than Chrome
      const blobCopy = new Blob([blob], { type: 'application/pdf' })

      const objUrl = window.URL.createObjectURL(blobCopy)

      const link = document.createElement('a')
      link.href = objUrl
      link.download = 'invoice.pdf'
      link.click()

      setTimeout(() => {
        window.URL.revokeObjectURL(objUrl)
        link.remove()
      }, 250)
    } catch (e) {
      handleSdkError(e)
    } finally {
      setLoading(false)
    }
  }

  return { downloadInvoice, loading }
}

export default useDownloadInvoice
